import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { DarePlatform } from 'root/src/shared/@types/platforms';
import { dropDareDifficultyLevelEnum, RewardForValue, } from 'root/src/shared/constants/dropEvent';
import { zodResolver } from '@hookform/resolvers/zod';
import { memo } from 'react';
import { dareFormSchema, } from 'root/src/client/v2/_pages/add-campaign/contexts/addCampaignForm.context';
import { CompletionType, RewardType } from 'root/src/shared/rewards/constants';
export const DARE_FORM_DEFAULT_VALUES = {
    id: undefined,
    title: '',
    description: '',
    estimatedTime: '',
    hint: '',
    games: [],
    completion: {
        type: CompletionType.REVIEW,
    },
    platforms: [
        DarePlatform.Twitch,
    ],
    level: dropDareDifficultyLevelEnum.n00b,
    amount: 1,
    battlePass: undefined,
    rewardFor: RewardForValue.FANS,
    product: {
        id: RewardType.PLACEHOLDER,
        name: 'Add later',
        type: RewardType.PLACEHOLDER,
    },
    reservedProducts: 0,
    expirationDate: undefined,
    disabled: false,
    clipsOnly: false,
};
export const DareFormContextProvider = memo((props) => {
    const form = useForm({
        defaultValues: DARE_FORM_DEFAULT_VALUES,
        resolver: zodResolver(dareFormSchema),
    });
    return (<FormProvider 
    // @ts-ignore
    rootForm={props.rootForm} {...form}>
			{props.children}
		</FormProvider>);
});
export function useDareFormContext() {
    return useFormContext();
}
